export default __webpack_public_path__ + "static/media/img-gt-mode-on-bg-uk_en@3x.5c7f5e11.jpg";